import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { registerGlobalNavigate } from "./navigationGlobal";

// Bridges React Router's navigate into the module-level navigation singleton so
// non-component code (the axios interceptor) can redirect. Mirrors ToastProvider
// registering addToast into toastGlobal. Renders nothing; must live inside the
// router.
const GlobalNavigationBridge = () => {
  const navigate = useNavigate();

  useEffect(() => {
    registerGlobalNavigate(navigate);
  }, [navigate]);

  return null;
};

export default GlobalNavigationBridge;
